var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBubbleChat = function SvgBubbleChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8.5H1.2C.54.5 0 1.04 0 1.7v10.8l2.4-2.4h8.4c.66 0 1.2-.54 1.2-1.2V1.7c0-.66-.54-1.2-1.2-1.2m0 8.4H2.4l-1.2 1.2V1.7h9.6zM3 4.7h1.2v1.2H3zm2.4 0h1.2v1.2H5.4zm2.4 0H9v1.2H7.8z"
  })));
};
export default SvgBubbleChat;